import {
  MULTIPLE_BRANDS_DISPLAY_LABEL,
  UNKNOWN_BRANDS_DISPLAY_LABEL,
} from '@/app/(authenticated)/(marketplace)/listings/constants';

export const getBrandDisplayFromBrandArray = (brandArray?: string[] | null): string => {
  if (!brandArray?.length) {
    return UNKNOWN_BRANDS_DISPLAY_LABEL;
  }
  if (brandArray.length === 1) {
    return brandArray[0];
  }
  return MULTIPLE_BRANDS_DISPLAY_LABEL;
};
